export default __webpack_public_path__ + "static/media/sccInfo.9ffc088a.svg";